import {
  FETCH_ALL_LICENSE_TYPES,
  ADD_NULL_LICENSE_TYPE,
} from '../../mutation-types';

export default {
  [FETCH_ALL_LICENSE_TYPES](state, licenseTypes) {
    state.all = licenseTypes;
  },
  [ADD_NULL_LICENSE_TYPE](state) {
    state.all.splice(0, '', { id: '', name: '' });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/licenseType/mutations.js